import { convertToBoolean } from './commonUtils';

export const sortBooleans = (values: (string | null)[]) => {
  return values.sort((a, b) => {
    const boolA = convertToBoolean(a);
    const boolB = convertToBoolean(b);
    if (boolA === boolB) {
      return 0;
    }
    return boolA ? -1 : 1;
  });
};

export const sortSalesStage = (values: (string | null)[]) => {
  const customOrder = ['Discovery', 'Visitor', 'Priority List', 'Reserved'];

  return values.sort((a, b) => {
    if (a === b) return 0;
    if (a == null) return 1;
    if (b == null) return -1;

    const indexA = customOrder.indexOf(a);
    const indexB = customOrder.indexOf(b);

    // If both values are in the custom order, sort by their order in customOrder
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // If only one value is in the custom order, sort alphabetically
    return a!.localeCompare(b!);
  });
};

export const sortMonetaryRanges = (values: (string | null)[]) => {
  const getMinValue = (str: string | null) => {
    if (!str) {
      return 0;
    }
    const match = str.match(/\$?([\d,]+)/);
    return match ? parseInt(match[1].replace(/,/g, ''), 10) : 0;
  };

  return values.sort((a, b) => {
    const minA = getMinValue(a);
    const minB = getMinValue(b);

    return minA - minB;
  });
};

export const sortRating = (values: (string | null)[]) => {
  const customOrder = ['Hot', 'Warm', 'Cold'];

  return values
    .filter(value => value !== null) // Remove null values
    .sort((a, b) => {
      const indexA = customOrder.indexOf(a!);
      const indexB = customOrder.indexOf(b!);

      // If both values are in the custom order, sort by their order in customOrder
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      // If only one value is in the custom order, sort alphabetically
      return a!.localeCompare(b!);
    });
};
